import { BiSearch } from 'react-icons/bi'
import { Icon, IconProps, forwardRef } from '@chakra-ui/react'

export const OmSearch = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} {...props} as={BiSearch} />
))
